import parse from 'date-fns/parse';

export default { parse };
